export const forceUpdate = {
  title: "アップデートのお願い",
  body: "最新バージョンのアプリでご利用いただけます。\nApp Store からアップデートしてください。",
  button: "アップデート",
} as const;
